export default
  [    {  name:'fpaPermanentList',
          path: '/fpaPermanentList',
          component: () =>
             import ('@/components/page/fpaManage/fpaPermanent/fpaPermanentList'),
          meta: { title: 'fpaManage.permanent.title' },
       },
      //  {  name:'fpaPermanentDetail',
      //     path: '/fpaPermanentDetail/:ttFpaId/:isCopy',
      //     component: () =>
      //         import ('@/components/page/fpaManage/fpaPermanent/fpaPermanentDetail'),
      //     meta: { title: 'fpaManage.permanent.detail' },
      //  },
       {  name:'fpaPermanentDetail',
          path: '/fpaPermanentDetail/:ttFpaId/:isCopy',
          component: () =>
              import ('../../components/page/fpaManage/fpaPermanent/newFpaDetail.vue'),
          meta: { title: 'fpaManage.permanent.detail' },
       },
       {  name:'fpaReportList',
          path: '/fpaReportList',
          component: () =>
              import ('@/components/page/fpaManage/fpaPermanent/fpaPermanentReport'),
          meta: { title: 'fpaManage.report_title' },
       },
       {  name:'fpaMateriaReportList',
          path: '/fpaMateriaReportList',
          component: () =>
              import ('@/components/page/fpaManage/fpaPermanent/fpaMaterialReport'),
          meta: { title: 'fpaManage.material_report_title' },
       },


      {  name:'fpaLtoCampaignList',
          path: '/fpaLtoCampaignList',
          component: () =>
              import ('@/components/page/fpaManage/fpaLtoCampaign/fpaLtoCampaignList'),
          meta: { title: 'fpaManage.ltoCampaign.title' },
      },
      // {  name:'fpaLtoCampaignDetail',
      //     path: '/fpaLtoCampaignDetail:ttFpaLtoCampaignId',
      //     component: () =>
      //         import ('@/components/page/fpaManage/fpaLtoCampaign/fpaLtoCampaignDetail'),
      //     meta: { title: 'fpaManage.ltoCampaign.detail' },
      // },
      {  name:'fpaLtoCampaignDetail',
          path: '/fpaLtoCampaignDetail:ttFpaLtoCampaignId',
          component: () =>
              import ('@/components/page/fpaManage/fpaLtoCampaign/newCampaign'),
          meta: { title: 'fpaManage.ltoCampaign.detail' },
      },



      {  name:'fpaLtoList',
          path: '/fpaLtoList',
          component: () =>
              import ('@/components/page/fpaManage/fpaLto/fpaLtoList'),
          meta: { title: 'fpaManage.lto.title' },
      },
      {  name:'fpaLtoDetail',
          path: '/fpaLtoDetail:ttFpaLtoId',
          component: () =>
              import ('@/components/page/fpaManage/fpaLto/fpaLtoDetail'),
          meta: { title: 'fpaManage.lto.detail' },
      },


]